module.exports = "/images/wix.png?ca4f4408efe80077d0fe43be094e5b02";